<div class="custom-slider">
    <ngx-slider [(value)]="minValue" [(highValue)]="maxValue" [options]="options"
        (userChangeEnd)="onUserChangeEnd($event)"></ngx-slider>
</div>
